import { render, staticRenderFns } from "./FormTradedoubler.vue?vue&type=template&id=d9119898"
import script from "./FormTradedoubler.vue?vue&type=script&lang=js"
export * from "./FormTradedoubler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports